module.exports = __webpack_public_path__ + "img/阻力带下拉.5c6075ee.png";